export const isValidCognitoPassword = (password) => {
    const minLength = 8;
    const hasNumber = /[0-9]/;
    const hasUppercase = /[A-Z]/;
    const hasLowercase = /[a-z]/;
    const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;

    return (
        typeof password === 'string' &&
        password.length >= minLength &&
        hasNumber.test(password) &&
        hasUppercase.test(password) &&
        hasLowercase.test(password) &&
        hasSymbol.test(password)
    )
}